import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { URL_LABELS } from '../service/endpoints';
import { getData } from '../service/APIClient';

export const fetchLabelData = createAsyncThunk(
  'home/fetchLabelData',
  async (id, thunkAPI) => {
    try {
      return await getData(URL_LABELS);
    } catch (error) {
      console.error('Error fetching labels: ', error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAccessPointData = createAsyncThunk(
  'home/fetchAccessPointData',
  async (id, thunkAPI) => {
    try {
      return await getData(`${URL_LABELS}/accessPoints`);
    } catch (error) {
      console.error('Error fetching access points: ', error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const homeSlice = createSlice({
  name: 'home',
  initialState: {
    labelData: [],
    accessPointData: [],
    labelStatus: 'idle',
    accessPointStatus: 'idle',
    error: null,
  },
  reducers: {
  },
  extraReducers: builder => {
    builder
      .addCase(fetchLabelData.pending, state => {
        state.labelStatus = 'loading';
      })
      .addCase(fetchLabelData.fulfilled, (state, action) => {
        state.labelStatus = 'succeeded';
        state.labelData = action.payload;
      })
      .addCase(fetchLabelData.rejected, (state, action) => {
        state.labelStatus = 'failed';
        state.error = action.payload || action.error.message;
      })
      .addCase(fetchAccessPointData.pending, state => {
        state.accessPointStatus = 'loading';
      })
      .addCase(fetchAccessPointData.fulfilled, (state, action) => {
        state.accessPointStatus = 'succeeded';
        state.accessPointData = action.payload;
      })
      .addCase(fetchAccessPointData.rejected, (state, action) => {
        state.accessPointStatus = 'failed';
        state.error = action.payload || action.error.message;
      })
  }
});

export default homeSlice.reducer;
